import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {SyncedVideoModel} from '../models';
import {syncedVideoEditStoreRenderer} from './synced-video-edit-store-renderer';
import {SyncedVideoEditStore} from './SyncedVideoEditStore';

@observer
export class X9SyncedVideoEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: SyncedVideoEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore }>) {
    super(props);

    this.store = new SyncedVideoEditStore();
    const value = props.store.content.Contents;
    const model = JSON.parse(value) as SyncedVideoModel;
    this.store.sync(model);

    this.setup();
  }

  render() {
    return Array.from(syncedVideoEditStoreRenderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
